import { AfterViewInit, Component, Inject, Input, OnInit, Output, ViewChild, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "app/modules/shared/services/api.service";
import { AlertMessage } from "app/shared/utils/alertMessage";
import * as moment from "moment";
import * as _ from "underscore";
import { TeamsListDialogComponent } from "../user-details/teams-list-dialog/teams-list-dialog.component";
import { RolePipePipe } from "../user-details-dialog/role-pipe.pipe";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CryptoService } from "app/shared/utils/crypto.service";

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  dataSource: MatTableDataSource<[]>;
  displayedColumns: string[] = [];
  @Input() data: any = [];
  @Input() iscenterFlag: any;
  @Input() tooltip: any;
  @Input() fix: any;
  @Output() teamsList: EventEmitter<any> = new EventEmitter();
  columns: any = [];
  message: any;
  dateType = "Month";
  colName: string;
  @Output() rowClicked = new EventEmitter();
  constructor(
    public dialogRef: MatDialogRef<TableComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private api: ApiService,
    private router: Router,
    private teamsDialog: MatDialog,
    private crypto: CryptoService
  ) {}

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
    }
  }
  getData(e) {
    this.data = [];
    this.dataSource = new MatTableDataSource([]);
    this.message = undefined;
    let key = "usageType=";
    if (this.dialogData.dateParameter == "PracticeSet") {
      key = e.type.toLowerCase() + "=";
    }
    this.api.get(this.dialogData.api + (e.date ? e.date : key + e.type.toLowerCase())).subscribe(
      (success) => {
        if (success && success.length > 0) {
          this.message = undefined;
          this.data = success.map(
            (data) =>
              (data = {
                fullName: data.firstName && data.firstName.trim() !== "" ? (data.firstName ? data.firstName : "") + (data.lastName ? " " + data.lastName : "") : data.username,
                email: data.email,
                nickname: new RolePipePipe().transform(data, "Guest") ? data.username : null,
                username: new RolePipePipe().transform(data, "Guest") ? null : data.username,
                // active: moment(data.active).format('MMMM d, YYYY')
                active: moment(data.active).format("LL"),
              })
          );

          this.setData();
        } else {
          this.message = "No data found";
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  async setData() {
    this.displayedColumns = [];
    this.columns = [];
    Object.keys(this.data[0]).map((ob: any) => {
      if (ob != "color" && this.data[0][ob] != null && !this.data[0][ob].hide) {
        this.displayedColumns.push(ob);
        const key = ob.split(/(?=[A-Z])/);
        this.columns.push({ colDef: ob, name: key[0] + " " + (key[1] ? key[1] : "") });
      }
    });
    if (this.paginator) {
      this.paginator.firstPage();
    }

    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].email) {
        this.data[i].emailDec = this.crypto.isProbablyEncrypted(this.data[i].email) ? await this.crypto.decryptData(this.data[i].email) : this.data[i].email;
      }
      if (this.data[i].username) {
        this.data[i].usernameDec = this.crypto.isProbablyEncrypted(this.data[i].username) ? await this.crypto.decryptData(this.data[i].username) : this.data[i].username;
      }
      if (this.data[i].nickname) {
        this.data[i].nicknameDec = this.crypto.isProbablyEncrypted(this.data[i].nickname) ? await this.crypto.decryptData(this.data[i].nickname) : this.data[i].nickname;
      }
      if (this.data[i].fullName) {
        this.data[i].fullName = this.crypto.isProbablyEncrypted(this.data[i].fullName) ? await this.crypto.decryptData(this.data[i].fullName) : this.data[i].fullName;
      }
    }

    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator = this.paginator;
  }

  getColName(col) {
    this.colName = col;
  }

  redirection(e) {
    if (this.dialogData.redirectionKey && e[this.dialogData.redirectionKey]) {
      this.dialogRef.close();
      this.router.navigate([this.dialogData.rediretionUrl, e[this.dialogData.redirectionKey]], { queryParams: { isRedirection: "yes" } });
    } else {
      this.teamsList.emit({ row: e, col: this.colName });
    }
  }
  applyFilter(event: Event) {
    if (this.dataSource && this.data.length > 0) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  getError(err) {
    if (err.status == 401) {
      this.api.notifyInfo(AlertMessage.exitingCurrentSession);
      this.api.logmeout();
    }
  }

  ngOnInit() {
    if (this.data && this.data[0]) {
      this.setData();
    } else if (this.dialogData && this.dialogData.header) {
      localStorage.setItem("updateDate", "No");
      this.dateType = this.dialogData.dateRange ? this.dialogData.dateRange : { type: "day" };
      this.getData({ type: this.dateType });
    } else {
      this.message = "No data found";
    }
  }

  openUserDialog(element) {
    this.rowClicked.emit(element);
  }
}
